"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.default = dispatchTrackingEvent;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dispatchTrackingEvent(data) {
  if ((0, _keys2.default)(data).length > 0) {
    (window.dataLayer = window.dataLayer || []).push(data);
  }
}


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/react-tracking/build/dispatchTrackingEvent.js
// module id = eA1e
// module chunks = 19